import DashboardService from '../services/dashboardService';
import {variableTypes} from "../../components/dashboard/control-widget/selection-contorl/constants";

export default class TemplateParser {
  /**
   * Parse template.
   * ex) "value of foo is ${foo}" => "value of foo is 100"
   * @param template
   * @returns {*}
   */
  static parseTemplate(template, strictType = false, variables = null) {
    if(!template) return;
    const dashboardVariables = variables || DashboardService.getCurrentDashboardVariables();
    const variableMatch = template.match(/\${([^}]+)}/g);
    if (variableMatch) {
      variableMatch.forEach(match => {
        const variableName = match.substr(2, match.length - 3);
        for (let variableId in dashboardVariables) {
          const v = dashboardVariables[variableId];
          let value = v.value;
          if (v.name === variableName) {
            if (strictType && TemplateParser.isStringType(v.type)) {
              value = `'${value}'`;
            }
            template = template.replace(match, value);
          }
        }
      });
    }
    return template;
  }

  static isStringType(variableType) {
    return [
      variableTypes.STRING,
      variableTypes.DATE,
      variableTypes.TIME,
      variableTypes.DATETIME,
      variableTypes.UUID].indexOf(variableType) > -1;
  }
}


// WEBPACK FOOTER //
// ./src/core/utils/templateParser.js